<div class="border-container bg-white mb-3">
  <div class="header border-bottom border-2">
    <div class="px-4">
      <h3 class="pt-2 title">
        {{ "Sellers.Products.ContractData" | translate }}
      </h3>
    </div>
  </div>
  <ng-container *ngIf="hasBusinessRegistered; else elseTemplate">
    <form [formGroup]="registeredBusinessForm" *ngIf="registeredBusinessForm">
      <div class="row">
        <div class="col-6">
          <div class="mb-3">
            <label
              >{{ "Sellers.Products.ExactBusinessName" | translate }}
              <span class="text-danger">*</span></label
            >
            <input
              type="text"
              class="form-control"
              [formControl]="convertRegisteredFormControls('exactRegisterName')"
              placeholder="{{
                'Sellers.Products.ExactBusinessName' | translate
              }}"
            />
            <small
              class="text-danger"
              *ngIf="fvRegisteredBusiness.formErrors.exactRegisterName"
            >
              {{ fvRegisteredBusiness.formErrors.exactRegisterName }}
            </small>
          </div>
          <div class="mb-3">
            <label
              >{{ "Sellers.Products.RegisteredBusinessAddress" | translate }}
              <span class="text-danger">*</span></label
            >
            <input
              type="text"
              class="form-control"
              placeholder="{{
                'Sellers.Products.RegisteredBusinessAddress' | translate
              }}"
              [formControl]="
                convertRegisteredFormControls('registeredBusinessAddress')
              "
            />
            <small
              class="text-danger"
              *ngIf="fvRegisteredBusiness.formErrors.registeredBusinessAddress"
            >
              {{ fvRegisteredBusiness.formErrors.registeredBusinessAddress }}
            </small>
          </div>
          <div class="mb-3">
            <label
              >{{ "Sellers.Products.BusinessOwnerFullName" | translate }}
              <span class="text-danger">*</span></label
            >
            <input
              type="text"
              class="form-control"
              placeholder="{{
                'Sellers.Products.BusinessOwnerFullName' | translate
              }}"
              [formControl]="
                convertRegisteredFormControls('businessOwnerFullName')
              "
            />
            <small
              class="text-danger"
              *ngIf="fvRegisteredBusiness.formErrors.businessOwnerFullName"
            >
              {{ fvRegisteredBusiness.formErrors.businessOwnerFullName }}
            </small>
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3">
            <label
              >{{ "Sellers.Products.CommercialRegisterNumber" | translate }}
              <span class="text-danger">*</span></label
            >
            <input
              type="text"
              class="form-control"
              placeholder="{{
                'Sellers.Products.CommercialRegisterNumber' | translate
              }}"
              [formControl]="
                convertRegisteredFormControls('commericalRegisterNumber')
              "
            />
            <small
              class="text-danger"
              *ngIf="fvRegisteredBusiness.formErrors.commericalRegisterNumber"
            >
              {{ fvRegisteredBusiness.formErrors.commericalRegisterNumber }}
            </small>
          </div>
          <div class="mb-3">
            <label
              >{{ "Sellers.Products.TaxRegistrationNumber" | translate }}
              <span class="text-danger">*</span></label
            >
            <input
              type="text"
              class="form-control"
              placeholder="{{
                'Sellers.Products.TaxRegistrationNumber' | translate
              }}"
              [formControl]="
                convertRegisteredFormControls('taxRegistrationNumber')
              "
			  (keyup)="formatTaxRegistrationNumber()"
            />
            <small
              class="text-danger"
              *ngIf="fvRegisteredBusiness.formErrors.taxRegistrationNumber"
            >
              {{ fvRegisteredBusiness.formErrors.taxRegistrationNumber }}
            </small>
          </div>
          <div class="mb-3">
            <label
              >{{ "Sellers.Products.BusinessOwnerNationalIdNumber" | translate }}
              <span class="text-danger">*</span></label
            >
            <input
              type="text"
              class="form-control"
              placeholder="{{
                'Sellers.Products.BusinessOwnerNationalIdNumber' | translate
              }}"
              [formControl]="
                convertRegisteredFormControls('businessOwnerNationalID')
              "
            />
            <small
              class="text-danger"
              *ngIf="fvRegisteredBusiness.formErrors.businessOwnerNationalID"
            >
              {{ fvRegisteredBusiness.formErrors.businessOwnerNationalID }}
            </small>
          </div>
        </div>
      </div>
      <button
        type="submit"
        class="btn btn-primary my-3 btn-lg"
        (click)="onSubmit()"
      >
        {{ "Sellers.Products.Submit" | translate }}
      </button>
    </form>
  </ng-container>
  <ng-template #elseTemplate>
    <form
      [formGroup]="unRegisteredBusinessForm"
      *ngIf="unRegisteredBusinessForm"
    >
      <div class="row">
        <div class="col-6">
          <div class="form-group mb-3">
            <label
              >{{ "Sellers.Products.BusinessName" | translate }}
              <span class="text-danger">*</span></label
            >
            <input
              [disabled]="ViewRequestFlag"
              placeholder="{{ 'Sellers.Products.BusinessName' | translate }}"
              [formControl]="convertUnRegisteredFormControls('businessName')"
              class="form-control"
            />
            <small
              class="text-danger"
              *ngIf="fvUnRegisteredBusiness.formErrors.businessName"
            >
              {{ fvUnRegisteredBusiness.formErrors.businessName }}
            </small>
          </div>
        </div>
        <div class="col-6">
          <div class="mb-3">
            <div class="form-group">
              <label
                >{{ "Sellers.Products.FullName" | translate }}
                <span class="text-danger">*</span></label
              >
              <input
                [disabled]="ViewRequestFlag"
                placeholder="{{ 'Sellers.Products.FullName' | translate }}"
                [formControl]="convertUnRegisteredFormControls('fullName')"
                class="form-control"
              />
              <small
                class="text-danger"
                *ngIf="fvUnRegisteredBusiness.formErrors.fullName"
              >
                {{ fvUnRegisteredBusiness.formErrors.fullName }}
              </small>
            </div>
          </div>
        </div>
      </div>
      <div class="form-group">
        <label
          >{{ "Sellers.Products.NationalIDNumber" | translate }}
          <span class="text-danger">*</span></label
        >
        <input
          [disabled]="ViewRequestFlag"
          placeholder="{{ 'Sellers.Products.NationalIDNumber' | translate }}"
          [formControl]="convertUnRegisteredFormControls('nationalID')"
          class="form-control"
        />
        <small
          class="text-danger"
          *ngIf="fvUnRegisteredBusiness.formErrors.nationalID"
        >
          {{ fvUnRegisteredBusiness.formErrors.nationalID }}
        </small>
      </div>
      <button
        type="submit"
        class="btn btn-primary my-3 btn-lg"
        (click)="onSubmit()"
        [disabled]="isSubmitted || !contractFormStatusService.getContractFormStatus(0)"
      >
        <ng-container *ngIf="isSubmitted">
          {{ "Sellers.Products.ActionSubmitted" | translate }}
        </ng-container>
        <ng-container *ngIf="!isSubmitted">
          {{ "Sellers.Products.Submit" | translate }}
        </ng-container>
      </button>
    </form>
  </ng-template>
</div>
